import { render } from "./CategoryButton.vue?vue&type=template&id=9122b806&scoped=true"
import script from "./CategoryButton.vue?vue&type=script&lang=js"
export * from "./CategoryButton.vue?vue&type=script&lang=js"

import "./CategoryButton.vue?vue&type=style&index=0&id=9122b806&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9122b806"]])

export default __exports__